import { t, type Lang } from '../lib/i18n'

interface SuccessStateProps {
  lang: Lang
  variant: 'request' | 'feedback'
  issueNumber: number
  issueUrl: string
  onReset: () => void
}

export function SuccessState({ lang, variant, issueNumber, issueUrl, onReset }: SuccessStateProps) {
  const bodyKey = variant === 'request' ? 'success.body.request' : 'success.body.feedback'
  return (
    <div
      role="status"
      aria-live="polite"
      className="rounded-lg border border-success/30 bg-success/10 p-6"
    >
      <div className="mb-2 text-2xl leading-none">✓</div>
      <h2 className="text-lg font-semibold text-text">{t(lang, 'success.title')}</h2>
      <p className="mt-2 text-sm text-text-muted">{t(lang, bodyKey)}</p>
      <div className="mt-4 flex flex-wrap items-center gap-4">
        {issueUrl && (
          <a
            href={issueUrl}
            target="_blank"
            rel="noopener"
            className="text-sm font-medium text-primary-text underline underline-offset-4 hover:no-underline"
          >
            {t(lang, 'success.viewIssue')} #{issueNumber} →
          </a>
        )}
        <button
          type="button"
          onClick={onReset}
          className="text-sm text-text-muted underline-offset-4 hover:underline"
        >
          {t(lang, 'success.again')}
        </button>
      </div>
    </div>
  )
}
